import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IMessengerConnector } from '../../../../types/all.type';
import { SenderHistoryResults } from '../../../../types/sende.type';
import { NgxModalDraggableDirective } from '../../../../directives/draggable.directive';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-result-contacts',
  templateUrl: './modal-result-contacts.component.html',
  styleUrls: ['./modal-result-contacts.component.scss']
})
export class ModalResultContactsComponent implements OnInit {

  @Input() modalMode = false;
  @Input() Service: IMessengerConnector;
  @Input() sender: SenderHistoryResults;
  public modalDirective: NgxModalDraggableDirective;
  langs: any = {
    ru: {
      JOIN_NOT_HELP: 'Не помогла подписка',
      USERNAME_INVALID: 'Адрес не найден',
      USERNAME_NOT_OCCUPIED: 'Адрес свободен',
      CHANNEL_PRIVATE: 'Приватный канал',
      CHAT_RESTRICTED: 'Чат ограничен',
      USERNAME_NOT_FOUND: 'Чат не найден',
      'TYPE_CHAT_ERROR:channel': 'Является каналом'

    }
  };

  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(private cd: ChangeDetectorRef, public bsModalRef: BsModalRef) {
  }
  get contactsResult(): any {
    return JSON.parse(this.sender?.contacts_result || '{}');
  }
  get resultsKeys(): any {
    return Object.keys(this.contactsResult);
  }

  ngOnInit(): void {
  }
  color(data: {status: string | number, link: string | null}): string {
    if (typeof data.status === 'number') {
      return 'success';
    }
    switch (data.status) {
      case 'JOIN_NOT_HELP':
        return 'warning';
      case 'USERNAME_INVALID':
        return 'warning';
      case 'USERNAME_NOT_OCCUPIED':
        return 'info';
      case 'TYPE_CHAT_ERROR:channel':
      default:
        return 'danger';
    }
  }

}
